if (typeof isDigital === undefined) {
  var isDigital = false;
}

var inputEmails = "";
var inputEmailsElement = document.getElementById("input_emails");
if ( inputEmailsElement !== undefined && inputEmailsElement !== null){
    inputEmails = inputEmailsElement.value;
}

var inputOrganization = "";
var inputOrganizationElement = document.getElementById("input_organization");
if ( inputOrganizationElement !== undefined && inputOrganizationElement !== null){
    inputOrganization = inputOrganizationElement.value;
}


var inputvideo = document.querySelector('[data-media-video-id^="DigitalProduct-template-video"]').getElementsByClassName("media-video")[0]
if ( inputvideo !== undefined && inputvideo !== null){
	if (locale === 'fr') {
	inputvideo.setAttribute('src', "https://cdn.shopify.com/videos/c/o/v/4a5c4142163748108a08c34523628eb7.mp4");
	}
	else{
	inputvideo.setAttribute('src', "https://cdn.shopify.com/videos/c/o/v/3eb32a14371d4edcbbf5ac4e188d9d8a.mp4");
	}
}


if (isDigital) {
	window.addEventListener('load', (event) => {
		const propertiesMap = decodeURL();
		if (propertiesMap.size > 0) {
			isModified = true;
			fillDigitalFields(propertiesMap);
			let buttonText = document.getElementById('addToCart_button_text');
			buttonText.textContent = locale === 'fr' ? "Modifier l'item" : "Update product";
		}
	});

	// DIGITAL function.
	// Organization must not be empty and contain at least one alphanumeric character.
	function validateOrganization() {
	  let input = document.getElementById('input_organization');
	  let error = document.getElementById('organization_error_wrapper');
	  businessMode = document.getElementById('BusinessModeSelector').options[ document.getElementById('BusinessModeSelector').selectedIndex ].value;
	  if ( businessMode === 'business' && input.value === 'personal' ) {
		displayError(error, theme.strings.organization_personalBusiness_error);
		error.removeAttribute('hidden');
		return false;
	  }	
	  if (containsAlphanumericCharacter(input.value)) {
		clearError(error);
		return true;
	  } else if(input.value === '') {
		displayError(error, theme.strings.organization_missing_error);
		error.removeAttribute('hidden');
		return false;
	  }
	  displayError(error, theme.strings.organization_name_error);
	  error.removeAttribute('hidden');
	  return false;
	}

	function validateEmails(quantity){
		let input = document.getElementById("input_emails");
		let error = document.getElementById("email_error_wrapper");

		// List of characters to be replaced by commas
		const replaceChars = [' ', ';', ':', '|', '\r', '\n'];

		// Dynamically create a regular expression to match any of the characters in the list
		const replaceRegex = new RegExp(`[${replaceChars.map(char => (char === '\r' || char === '\n') ? char : '\\' + char).join('')}]+`, 'g');

		// Replace all listed characters with a comma using the generated regex
		let emailsWithCommas = input.value.replace(replaceRegex, ',').replace(/,+/g, ',');

		// Trim leading and trailing commas
		let formattedEmails = emailsWithCommas.replace(/^,|,$/g, '');

		// Split the formatted string into an array of emails
		let emails = formattedEmails.split(',');

		for (let i = 0; i < emails.length; i++) {
		if(!isValidEmail(emails[i])){
			displayError(error, theme.strings.email_format_error.replace('[EMAIL]',emails[i]));
			error.setAttribute('style', 'color: red');
			error.removeAttribute('hidden');
			return false;
		}
		}

		if(emails.length != quantity){ // Display error when user does not enter the right amount of emails
		displayError(error, theme.strings.email_number_error.replace('[EMAIL_QUANTITY]',emails.length).replace('[QUANTITY]',quantity));
		error.setAttribute('style', 'color: red');
		error.removeAttribute('hidden');
		return false;
		}

		inputEmails = formattedEmails;
		return true;
	}

	function isValidEmail(email){
	  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	  return re.test(email);
	}

	function updateBusinessMode() {
	  let hideClass = "hide";

	  businessMode = document.getElementById('BusinessModeSelector').options[ document.getElementById('BusinessModeSelector').selectedIndex ].value;
	  inputOrganization = businessMode;
	  document.getElementById('Quantity-DigitalProduct-template').value=1;

	  if(businessMode == "business"){
		  document.getElementById('product-form_business_input').classList.remove(hideClass);
		  document.getElementById('product-form_business_input_quantity').classList.remove(hideClass);
		  document.getElementById('input_organization').value="";
		}
	  else{
		  document.getElementById('product-form_business_input').classList.add(hideClass);
		  document.getElementById('product-form_business_input_quantity').classList.add(hideClass);
		  document.getElementById('input_organization').value="personal";
		  document.getElementById('input_emails').value=""; 
		}
	}

	function fillDigitalFields(propertiesMap) {
		
		var organizationURL = propertiesMap.get('Organization');
		if (organizationURL === "personal")
		{
			document.getElementById('BusinessModeSelector').selectedIndex = 1;
			updateBusinessMode();
		}
		else{
			document.getElementById('BusinessModeSelector').selectedIndex = 0;
			updateBusinessMode();
			document.getElementById('Quantity-DigitalProduct-template').value = propertiesMap.get('quantity');
			document.getElementById('input_organization').value = organizationURL;
			document.getElementById('input_emails').value = propertiesMap.get('Emails');
		}

	 }
 }